import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form } from "react-bootstrap";
import BreadcrumbsSection from "../breadcrumbs/BreadcrumbsSection";
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';
import MultiSelect from "react-multi-select-component";


import moment from "moment";
import './_offlinefee.scss'

const FeeType = [
    { id: 1, label: "Tution fee" },
    { id: 2, label: "Bus fee" },
]

const Studentsdata = [
    {
        student_name: "Riya",
        class: "XI/JEE",
        total_amount: "10000",
        discount: "2000",
        amount_payable: "8000",
        amount_paid: "3000",
        amount_due: "5000",
    },
    {
        student_name: "Sai",
        class: "XI/JEE",
        total_amount: "10000",
        discount: "2000",
        amount_payable: "8000",
        amount_paid: "8000",
        amount_due: "0",
    }, {
        student_name: "Kumar",
        class: "XI/JEE",
        total_amount: "10000",
        discount: "2000",
        amount_payable: "8000",
        amount_paid: "3000",
        amount_due: "5000",
    }, {
        student_name: "Teja",
        class: "XI/JEE",
        total_amount: "10000",
        discount: "2000",
        amount_payable: "8000",
        amount_paid: "8000",
        amount_due: "0",
    }, {
        student_name: "Murali",
        class: "XI/JEE",
        total_amount: "10000",
        discount: "2000",
        amount_payable: "8000",
        amount_paid: "3000",
        amount_due: "5000",
    }, {
        student_name: "Ram",
        class: "XI/JEE",
        total_amount: "10000",
        discount: "2000",
        amount_payable: "8000",
        amount_paid: "8000",
        amount_due: "0",
    },

]

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
      }
      globalBranches {
        id
        branch_name
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
      }
      offlineExamSubjects{
        id
        subject
      }
    }
  }
`;

class OfflineFeeStructureSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            defaultvalue: 0,
            branch: "",
            branchError: "",

            class: [],
            classValue:[],
            classError: "",

            section: "",
            sectionError: "",

            exam: [],
            examValue:[],
            examError: "",

            examType: "",
            examTypeError: "",

            examName: "",
            examNameError: "",

            fee: "",
            feeTypeError: "",
            tableDisplay: false,

            examsArrayGlobals:[],

        }
    }
    

    handleInputChange = e => {

        const name = e.target.name;
        const value = e.target.value;
        console.log("handleInputChange", name, value)

        this.setState({ [name]: value }, () => {
            // this.validateField(name, value);
        });
    };

    handleMultipleSelectInputChange = (e, name) => {
        console.log("handleMultipleSelectInputChange", e, name);
        if (name == "exam") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    console.log("qbtopicval", qbtopicval)
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value
                    }
                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                }
                this.setState({
                    examValue: qbsearchtopicvalue,
                    exam: qbsearchtopic
                });
            }
        }else  if (name == "class") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    console.log("qbtopicval", qbtopicval)
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value
                    }
                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                }
                this.setState({
                    classValue: qbsearchtopicvalue,
                    class: qbsearchtopic
                });
            }
        }
    }

    articlecolumns = [
        {
            dataField: "student_name",
            text: "Student Name",
        },

        {
            dataField: "class",
            text: "Class/Exam",
        },
        {
            dataField: "total_amount",
            text: "Total amount",
        },
        {
            dataField: "discount",
            text: "Discount",
        },
        {
            dataField: "amount_payable",
            text: "Amount Payable",
        },
        {
            dataField: "amount_paid",
            text: "Amount Paid",
        },
        {
            dataField: "amount_due",
            text: "Amount Due",
        },
        {
            dataField: "payment_status",
            text: "Payment Status",
            formatter: this.paymentStatus.bind(this)
        },

    ];

    paymentStatus(cell, row, rowIndex, formatExtraData) {
        console.log("rowwwwwww", row)
        return (
            <>
                {
                    row.amount_due == 0 ?
                        (<Button className="btn btn-success paid_btn">Paid</Button>)
                        :
                        (<Button className="btn btn-danger paid_btn">Due</Button>)
                }
            </>
        )
    }

    getDetails = async () => {
        this.setState({ tableDisplay: true })

    }
    render() {

        console.log("chaitu", this.state.examValue,this.state.classValue)

        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        if (loading1) return null;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }
        let globalsData = [];

        if (!loading1) {
            globalsData = this.props.globals.globals
        }


        let sections = [];
        if (this.state.exam != "") {
            globalsData.globalPackages.map((item) => {
                if (item.exams_covered == this.state.exam) {
                    globalsData.globalCategories.map((stumap) => {
                        if (stumap.package_id == item.id) {
                            globalsData.globalSections.map((stumap1) => {
                                if (stumap1.category_id == stumap.id) {
                                    const newObj = {
                                        id: stumap1.id,
                                        section_name: stumap1.section_name
                                    }
                                    sections.push(newObj);
                                }
                            })
                        }
                    });
                }
            });
        }

        let examsArray = []

        globalsData.exams.map((item) => {
            const newObj = {
                value: item.id,
                label: item.exam
            }
            examsArray.push(newObj)
        })

        let examSelectAll = true;
        let examlabelledby = "Select Exam";
        let examdisablesearch = false;
        if (examsArray.length > 0) {
            examSelectAll = true;
            examdisablesearch = false;
        }
        else {
            examdisablesearch = true;
            examSelectAll = false;
            examlabelledby = "Exams"
        }

        
        let classArray=[]

        globalsData.classes.map((item)=>{
            const newObj={
                value:item.id,
                label:item.class
            }
            classArray.push(newObj)
        })

        let classSelectAll = true;
        let classlabelledby = "Select Class";
        let classdisablesearch = false;
        if (classArray.length > 0) {
            classSelectAll = true;
            examdisablesearch = false;
        }
        else {
            classdisablesearch = true;
            classSelectAll = false;
            classlabelledby = "Class"
        }

        return (
            <Container className="exam_report_section">
                <Row className="mt-5">
                    <Col sm={12}>
                        <Form>
                            <Form.Row>
                                {/* No Branch picker — the header (NavbarOne) scopes this page. */}

                                <Form.Group as={Col} xl={2} lg={2} md={12} sm={12} controlId="SelectClass">
                                    <Form.Label className="text-uppercase">Class</Form.Label>
                                    <MultiSelect
                                        overrideStrings={{
                                            "allItemsAreSelected": "All Classes are selected.",
                                            "selectSomeItems": classlabelledby
                                        }}
                                        disableSearch={classdisablesearch}
                                        hasSelectAll={examSelectAll}
                                        options={classArray}
                                        value={this.state.classValue}
                                        onChange={(e) => this.handleMultipleSelectInputChange(e, "class")}
                                        labelledBy={"Class"}
                                    />
                                    <Form.Text className="form-text text-danger">
                                        {this.state.examError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} xl={2} lg={2} md={12} sm={12} controlId="Selectexam">
                                    <Form.Label className="text-uppercase">Exam</Form.Label>
                                    <MultiSelect
                                        overrideStrings={{
                                            "allItemsAreSelected": "All Exams are selected.",
                                            "selectSomeItems": examlabelledby
                                        }}
                                        disableSearch={examdisablesearch}
                                        hasSelectAll={examSelectAll}
                                        options={examsArray}
                                        value={this.state.examValue}
                                        onChange={(e) => this.handleMultipleSelectInputChange(e, "exam")}
                                        labelledBy={"Exams"}
                                    />
                                    <Form.Text className="form-text text-danger">
                                        {this.state.examError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="selectFee">
                                    <Form.Label className="text-uppercase">Fee Type</Form.Label>
                                    <Form.Control as="select" name="fee" onChange={this.handleInputChange} value={this.state.fee}>
                                        <option value={this.state.defaultvalue}>--Select Fee Type--</option>
                                        {FeeType.map(item => (
                                            <option value={item.id}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.feeTypeError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="">
                                    <Button className="text-uppercase submit_btn_report" onClick={(e) => this.getDetails()}>Get Details</Button>
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </Col>
                </Row>

                {
                    this.state.tableDisplay == true ?
                        (
                            <>
                                <Row className="mt-3">
                                    <Col sm={3}>
                                        <Card className='border_card'>
                                            <Card.Body className="p-2">
                                                <h5 className="text-center card_header">Payments Due</h5>
                                                <p className="text-center card_des">3</p>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col sm={3}>
                                        <Card className='border_card'>
                                            <Card.Body className="p-2">
                                                <h5 className="text-center card_header">Payments pending</h5>
                                                <p className="text-center card_des">3</p>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col sm={3}>
                                        <Card className='border_card'>
                                            <Card.Body className="p-2">
                                                <h5 className="text-center card_header">Pending amount Due</h5>
                                                <p className="text-center card_des">15000</p>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>


                                <Row className="mt-5">
                                    <Col sm={12}>
                                        <CardLessDataTableWithOutSearch
                                            parentData={Studentsdata}
                                            particlecolumns={this.articlecolumns}
                                        />
                                    </Col>
                                </Row>
                            </>
                        )
                        :
                        ("")
                }


            </Container>
        )
    }
}

export default withRouter(withApollo(compose(
    graphql(FETCH_GLOBALS, {
        options: (props) => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "globals",
    }),
)(OfflineFeeStructureSection))
);